import { Link } from 'react-router-dom';
import { getHotArticles } from '@/mocks/articles';

export default function TrendingSidebar() {
  const hotArticles = getHotArticles().slice(0, 8);

  return (
    <section className="w-full bg-background-50 py-12 md:py-16">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-center gap-3 mb-8">
          <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-accent-500">
            <i className="ri-fire-fill text-background-50 text-xl"></i>
          </div>
          <div>
            <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 font-heading">
              热门排行
            </h2>
            <p className="text-sm text-foreground-500 mt-1">全网最热猛料榜单</p>
          </div>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
          {hotArticles.map((article, index) => (
            <Link
              key={article.id}
              to={`/article/${article.id}`}
              className="group flex items-start gap-4 p-4 rounded-lg bg-background-100 hover:bg-primary-50 border border-background-200/70 hover:border-primary-200 transition-all cursor-pointer"
            >
              <div className={`flex-shrink-0 w-8 h-8 flex items-center justify-center rounded-lg font-bold text-sm font-heading ${
                index < 3
                  ? 'bg-accent-500 text-background-50'
                  : 'bg-background-200 text-foreground-500'
              }`}>
                {index + 1}
              </div>
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 mb-1">
                  <span className="px-2 py-0.5 bg-background-200 text-foreground-600 text-xs rounded-full whitespace-nowrap">
                    {article.category}
                  </span>
                </div>
                <h3 className="font-semibold text-foreground-900 group-hover:text-primary-500 transition-colors font-heading text-sm line-clamp-2">
                  {article.title}
                </h3>
                <div className="flex items-center gap-3 mt-2 text-xs text-foreground-500">
                  <span className="flex items-center gap-1">
                    <i className="ri-eye-line"></i> {article.views.toLocaleString()}
                  </span>
                  <span className="flex items-center gap-1">
                    <i className="ri-message-2-line"></i> {article.comments.toLocaleString()}
                  </span>
                  <span>{article.publishedAt}</span>
                </div>
              </div>
              <div className="flex-shrink-0 w-20 h-20 rounded-lg overflow-hidden hidden sm:block">
                <img
                  src={article.image}
                  alt={article.title}
                  className="w-full h-full object-cover object-top"
                />
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}